/**************************************************
 * Nombre:       Formulario_Video_Tres
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Divider, Grid, Typography} from "@mui/material";
import {DriveFileRenameOutline, TitleOutlined} from "@mui/icons-material";
import IngresoTexto from "../../../Modulo_formularios/Componentes/IngresoTexto";
import IngresoVideo from "../../../Modulo_formularios/Componentes/IngresoVideo";
import IngresoSelectFalsoVerdadero from "../../../Modulo_formularios/Componentes/IngresoSelectFalsoVerdadero";
import IngresoCheckGrupoMulti from "../../../Modulo_formularios/Componentes/IngresoCheckGrupoMulti";
import {LISTADATOS} from "../../../Constantes";

const Formulario_Video_Tres = ({...props}) => {

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={12}>
                    <Divider sx={{width: '100%'}}/>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Blanco'} dato={'tituloTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Titulo Resaltado'}
                                  dato={'tituloResaltadoTres'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoVideo dato={'videoTres'}  {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Parrafo'} dato={'tituloParrafoTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Rosado'}
                                  dato={'rosadoTituloParrafoTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Blanco'}
                                  dato={'blancoTituloParrafoTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Celeste'}
                                  dato={'celesteTituloParrafoTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={4} nombre={'Parrafo'} dato={'parrafoTres'} {...props}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', px: 1}}>
                    <Typography>Formulario al finalizar el video</Typography>
                </Grid>

                <Grid container size={6} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelectFalsoVerdadero nombre={'Mostrar Formulario'} dato={'formularioSiTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={TitleOutlined} nombre={'Titulo Formulario'}
                                  dato={'tituloFormularioTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={DriveFileRenameOutline} nombre={'Resaltado Titulo Formulario'}
                                  dato={'rosadoTituloFormularioTres'} {...props}
                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={3} nombre={'Parrafo Fomrulario'}
                                  dato={'parrafoFormularioTres'} {...props}
                    />
                </Grid>


                <Grid container size={12}>
                    <IngresoCheckGrupoMulti nombre={'Datos Formulario'}
                                            dato={'datosTres'} {...props}
                                            opciones={LISTADATOS}
                    />
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Video_Tres